import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import SearchBar from '../Components/SearchBar';
import { getAllInvoicesForSpecialCase, getDueAmounts, updateStatusForFinance, getBudgetAmount } from '../store/actions/invoiceActions';
import { getallMasterData } from '../store/actions/masterActions';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import UploadAcknowledgementPopUp from '../Components/UploadAcknowledgementPopUp';
import authInstance from '../Classes/AuthHandler';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import DocumentCommentAdvancePopUp from '../Components/DocumentCommentAdvancePopUp';
import toast from 'react-hot-toast';
import Loading from '../Components/Loader';
//import { Button } from 'react-bootstrap';
import env from '../ENV';
import { CSVLink } from "react-csv";
import Papa from 'papaparse';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from '@sweetalert/with-react';
import { postMapPaymentAcknowledgementDocumentIDsToInvoice } from './../store/actions/poDetailsActions'


class ReqPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            invoicetabledata: [],
            supplierName: "ABC Tech Inc.",
            select: true,
            checked: [],
            checkedPOID: [],
            UploadAcknowledgementModal: false,
            selectAll: false,
            modal: false,
            paymentMethod: [],
            selectedpaymentmethod: "",
            InvoiceAmountinINR: [],
            TotalPaidAmount: [],
            InvoiceNo: [],
            select: false,
            selected: [],
            checkedArray: [],
            budget: 0,
            Curr_Day: "",
            finalLastDay: "",
            DocumentCommentAdvancePopUpModal: false,
            varId: "",
            approvedAmount: 0,
            csvData: [],
            csvFile: [],
            UploadDocumentmodal: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.UploadAcknowledgementModal = this.UploadAcknowledgementModal.bind(this);
        this.DocumentCommentAdvancePopUpModal = this.DocumentCommentAdvancePopUpModal.bind(this);
    }
    datemanipulation() {
        var d = new Date()
        var first = d.getDate() - d.getDay();
        var EndDate = this.formatDate(new Date(d.setDate(first + 6)))
        var StartDate = this.formatDate(new Date(d.setDate(first)))

        this.setState({ Curr_Day: StartDate, finalLastDay: EndDate })
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    UploadAcknowledgementModal() {
        this.setState({ UploadAcknowledgementModal: !this.state.UploadAcknowledgementModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.UploadAcknowledgementModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleUploadAcknowledgementModal = async (e) => {
        this.setState({ UploadAcknowledgementModal: !this.state.UploadAcknowledgementModal });
        if (this.state.UploadAcknowledgementModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
            // await this.dataSyns()
        }
    }

    handleSelect = (e) => {

        this.setState({
            selectedpaymentmethod: e.target.value
        })
    }

    dataSyns = async () => {
        this.setState({ loading: true })
        var role = Object.keys(authInstance.getRoles())[0]
        var group = Object.keys(authInstance.getGroups())[0]
        var approvedAmount = 0
        await this.props.getAllInvoicesForSpecialCase(role, group)
        if (this.props.invoices.allInvoicesSpl && this.props.invoices.allInvoicesSpl.recordset && this.props.invoices.allInvoicesSpl.recordset.length > 0) {
            // this.props.invoices.allInvoices.recordset.map()
            let invoicetabledata = [];
            let csvData = [];
            await this.props.invoices.allInvoicesSpl.recordset.map((item) => {
                let itemData = item
                itemData.NewPayableAmount = 0;
                if (parseFloat(itemData.TotalPaidAmount) <= 0) {
                    invoicetabledata.push(itemData)
                    approvedAmount = parseFloat(approvedAmount) + parseFloat(itemData.PayableAmount)
                }
            })
            invoicetabledata.map(async (item) => {
                await csvData.push({
                    "Plant Code": item.PlantCode,
                    "Invoice Id": parseInt(item.InvoiceId),
                    "Invoice No": "INV - "+item.InvoiceNo,
                    "Payment Counter": item.Counter !== null ? `Part-${item.Counter}` : '',
                    "Invoice Date": dateFormater(this.formatDate(item.InvoiceDate)),
                    "Due Date": dateFormater(this.formatDate(item.DueDate)),
                    "Vendor Name": item.VendorName + " - " + item.VendorSapId,
                    "Invoice Type": item.PaymentTypeName + " Against " + item.TypeFor,
                    "Vendor Type": item.SSIType == "" ? "NON MSME" : "MSME",
                    "PO No": item.POSAPId,
                    "Project code": item.WBSNo? item.WBSNo.substring(0, 2) == 'ET' ? (item.WBSNo).slice(0, 11) : (item.WBSNo).slice(0, 6) : "Others",
                    "currency": item.CurrencyType,
                    "Invoice Amount": item.InvoiceAmount ? numberWithCommas(item.InvoiceAmount) : 0,
                    "Invoice Amount in (INR)": item.InvoiceAmountinINR ? numberWithCommas(item.InvoiceAmountinINR) : 0,
                    "Advance Deduction": item.AdvanceDeduction ? numberWithCommas(item.AdvanceDeduction) : 0,
                    "Retention Deduction": item.RetentionDeduction ? numberWithCommas(item.RetentionDeduction) : 0,
                    "LD Deduction": item.LDDeduction ? numberWithCommas(item.LDDeduction) : 0,
                    "TDS Deduction": item.TDSDeduction ? numberWithCommas(item.TDSDeduction) : 0,
                    "Others Deduction": item.OthersDeduction ? numberWithCommas(item.OthersDeduction) : 0,
                    "Reason For Others": item.ReasonForOthersDeduction,
                    "SAP Doc. Number": item.SAPDocNo,
                    "SAP Doc. Date": item.SAPDocDate ? dateFormater(item.SAPDocDate) : "",
                    "Net Payable Amount": numberWithCommas(item.NetPayableAmount),
                    "Approved Amount": numberWithCommas(item.PayableAmount),
                    "Payment Method": item.PaymentMediumName,
                    "Status": item.InvoiceStatusName,
                    "UTR No": '',
                    "Payment Date": 'dd-mm-yyyy',
                    "Payment Advice No": ''
                })
            })
            await this.setState({ invoicetabledata, approvedAmount, csvData })
        }
        this.setState({ loading: false })
        var EndDate = this.state.finalLastDay
        var StartDate = this.state.Curr_Day
        this.props.getBudgetAmount({
            StartDate: StartDate,
            EndDate: EndDate
        })
    }

    componentDidMount = async () => {
        await this.datemanipulation()
        await this.dataSyns()
        await this.props.getDueAmounts()
        await this.props.getallMasterData()
    }



    handleChange = () => {

        try {
            let selected = this.state.selected;
            let select = !this.state.select;
            var checkedArray = this.state.checkedArray
            this.props.invoices.allInvoicesSpl.recordset.map((item, index) => {
                selected[item.InvoiceId] = select;
                this.state.InvoiceAmountinINR.push(item.InvoiceAmountinINR)
                this.state.TotalPaidAmount.push(item.TotalPaidAmount)
                this.state.InvoiceNo.push(item.InvoiceNo)
                if (select == true) {
                    checkedArray.push(item.InvoiceId)
                } else {
                    checkedArray = []
                }
            });


            this.setState({ selected: selected, select: select, checkedArray, InvoiceAmountinINR: this.state.InvoiceAmountinINR, TotalPaidAmount: this.state.TotalPaidAmount, InvoiceNo:this.state.InvoiceNo });
        } catch (e) {
            console.log(e);
        }

    };

    handleSingleCheckboxChange = (index, InvoiceAmountinINR, TotalPaidAmount, InvoiceNo) => {
        var checkedArray = this.state.checkedArray
        let selected = this.state.selected;
        let status = index in selected ? !selected[index] : true
        selected[index] = status
        if (selected[index] == true) {
            checkedArray.push(index)
            this.state.InvoiceAmountinINR.push(InvoiceAmountinINR)
            this.state.TotalPaidAmount.push(TotalPaidAmount)
            this.state.InvoiceNo.push(InvoiceNo)
        } else {
            var index = checkedArray.indexOf(index);
            if (index !== -1) {
                checkedArray.splice(index, 1);
            }
        }
        this.setState({ selected, checkedArray, InvoiceAmountinINR: this.state.InvoiceAmountinINR, TotalPaidAmount: this.state.TotalPaidAmount, InvoiceNo: this.state.InvoiceNo });
    };

    fetchDate(date) {
        let dd = date.getDate().toString()
        let mm = (date.getMonth() + 1).toString()
        if (dd.length < 2)
            dd = "0" + dd
        if (mm.length < 2)
            mm = "0" + mm
        let finalDate = dd + "/" + mm + "/" + date.getFullYear();
        return finalDate;
    }
    daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
    }

    DocumentCommentAdvancePopUpModal() {
        this.setState({ DocumentCommentAdvancePopUpModal: !this.state.DocumentCommentAdvancePopUpModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.DocumentCommentAdvancePopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleDocumentCommentAdvancePopUpModal = async (e) => {
        await this.setState({ DocumentCommentAdvancePopUpModal: !this.state.DocumentCommentAdvancePopUpModal });
        if (this.state.DocumentCommentAdvancePopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", varId: "" }
            )
        }
    }

    rowClick = async (index) => {
        await this.setState({ varId: index })
        await this.DocumentCommentAdvancePopUpModal(index)
    }
    handleRevise = async () => {
        let array = [...new Set(this.state.checkedArrayRecall)];
        for (let i = 0; i < array.length; i++) {
            await this.props.updateStatusForFinance(1, array[i]).then(() => {
                toast.success(`Recall Successfull`, {
                    duration: 1000
                });
            })
        }
        await this.setState({ checkedArrayRecall: [], selectRecall: false })
        await this.dataSyns()
    }
    UploadDocumentmodal() {
        this.setState({ UploadDocumentmodal: !this.state.UploadDocumentmodal });
        if (this.state.UploadDocumentmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    handleCsv = async (event) => {
        var regex = new RegExp("(.*?)\.(csv)$");
        if (!(regex.test(event.target.value.toLowerCase()))) {
            event.target.value = '';
            swal("Please upload the file you have downloaded from the system", { icon: "error" })
            return false
        }
        let csvFile = event.target.files[0]
        await this.setState({ csvFile })
    }
    uploadCsv = async () => {
        this.setState({ loading: true })
        if (this.state.csvFile.length == 0) {
            swal("Please select a file to upload", { icon: "error" })
            return false
        }
        await Papa.parse(this.state.csvFile,
            {
                header: true,
                complete: async (results) => {
                    var data = results.data
                    var columnHeaders = Object.keys(data[0])
                    var finalColumns = ["Plant Code","Invoice Id","Invoice No","Payment Counter","Invoice Date","Due Date","Vendor Name","Invoice Type","Vendor Type","PO No","Project code","currency","Invoice Amount","Invoice Amount in (INR)","Advance Deduction","Retention Deduction","LD Deduction","TDS Deduction","Others Deduction","Reason For Others","SAP Doc. Number","SAP Doc. Date","Net Payable Amount","Approved Amount","Payment Method","Status","UTR No","Payment Date","Payment Advice No"]
                    if(columnHeaders.length !== 29 ){
                        swal("Column count does not match with exported file. It should be 29 but the uploaded file contais "+columnHeaders.length+" columns", { icon: "error" })
                        return false
                    }
                    if(columnHeaders[0] !== finalColumns[0] || columnHeaders[1] !== finalColumns[1] || columnHeaders[2] !== finalColumns[2] || columnHeaders[3] !== finalColumns[3] || columnHeaders[4] !== finalColumns[4] || columnHeaders[5] !== finalColumns[5] || columnHeaders[6] !== finalColumns[6] || columnHeaders[7] !== finalColumns[7] || columnHeaders[8] !== finalColumns[8] || columnHeaders[9] !== finalColumns[9] || columnHeaders[10] !== finalColumns[10] || columnHeaders[11] !== finalColumns[11] || columnHeaders[12] !== finalColumns[12] || columnHeaders[13] !== finalColumns[13] || columnHeaders[14] !== finalColumns[14] || columnHeaders[15] !== finalColumns[15] || columnHeaders[16] !== finalColumns[16] || columnHeaders[17] !== finalColumns[17] || columnHeaders[18] !== finalColumns[18] || columnHeaders[19] !== finalColumns[19] || columnHeaders[20] !== finalColumns[20] || columnHeaders[21] !== finalColumns[21] || columnHeaders[22] !== finalColumns[22] || 
                        columnHeaders[23] !== finalColumns[23] || columnHeaders[24] !== finalColumns[24] || columnHeaders[25] !== finalColumns[25] || columnHeaders[26] !== finalColumns[26] || columnHeaders[27] !== finalColumns[27] || columnHeaders[28] !== finalColumns[28]){
                        swal(<div><p>Column Missmatch found. Required columns are as follows </p><p>{finalColumns.join(',')}.</p> <p><b>But the uploaded file contais</b> </p><p>{columnHeaders.join(',')}</p></div>, { icon: "error" })
                        return false
                    }
                    for (let i = 0; i < data.length - 1; i++) {
                        await this.props.postMapPaymentAcknowledgementDocumentIDsToInvoice(
                            data[i]['Invoice Id'],
                            data[i]['Invoice No'],
                            authInstance.getUserID(),
                            data[i]['Payment Date'],
                            0,
                            data[i]['UTR No'],
                            data[i]['Payment Advice No'],
                        )
                    }
                    toast.success(`Payment Updated Successfully`, {
                        duration: 1000
                    });
                    this.setState({ loading: false })
                    await this.dataSyns()
                    await this.UploadDocumentmodal()
                }
            })
    }
    render() {
        var roles = authInstance.getRoles()
        var groups = authInstance.getGroups()
        var varId = this.state.varId
        if (this.props.masterReducerData.loading == false) {
            this.state.paymentMethod = this.props.masterReducerData.masterdata.recordset
        }
        try {

            if (this.props.invoices.loading == false) {
                this.state.budget = this.props.invoices.budgetamount.recordset[0].Amount
            }
        }
        catch (e) { }

        return (
            this.state.loading == true ?
                <Loading />
                :
            <div className="Container-fluid pageheight pl-2 pr-2 pt-2"  >
                {/*----------Document comment-------------- */}
                {varId ? (<DocumentCommentAdvancePopUp action={this.state.DocumentCommentAdvancePopUpModal} toggleDocumentCommentAdvancePopUpModal={(e) => this.toggleDocumentCommentAdvancePopUpModal(e)} InvoiceId={varId} path='/RequestPayment' />) : null}
                {/*----------Document Comment end  */}
                {this.state.checkedArray && this.state.InvoiceAmountinINR && this.state.TotalPaidAmount ?
                    <UploadAcknowledgementPopUp action={this.state.UploadAcknowledgementModal} invoiceIds={this.state.checkedArray} InvoiceAmountinINR={this.state.InvoiceAmountinINR} TotalPaidAmount={this.state.TotalPaidAmount} InvoiceNo={this.state.InvoiceNo} uploadedBy={authInstance.getUserID()} toggleUploadAcknowledgementModal={(e) => this.toggleUploadAcknowledgementModal(e)} path='/UploadPaymentAcknowledgement' />
                    : null}
                {/* BULK Upload MODAL Starts */}
                <Modal isOpen={this.state.UploadDocumentmodal} >
                    <div className={"modal-bg" + (this.state.UploadDocumentmodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Update Payment Information: </h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={() => { this.UploadDocumentmodal() }} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>
                        <div >
                            <ModalBody Style="modal-body">
                                <div className="row ml-2 pt-2">
                                    <div className="col-md-5"><b>Upload Excell File :</b></div>
                                    <div className="col-md-7">
                                        <input type="file" id='BGUpload' onChange={(e) => this.handleCsv(e)} />
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.UploadDocumentmodal() }} type="submit">Cancel</button>
                                    <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.uploadCsv()} type="submit">Upload</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>
                {/* BULK Upload MODAL ENDS */}
                <div className="row pt-2 pr-4">
                    <div className="col-4">
                        <b>REQUESTED PAYMENTS</b>
                    </div>
                    <div className="col-3">
                        {/* <button className="btn2 btn-sms1 float-right rounded-pill" onClick={this.UploadAcknowledgementModal} > Upload Acknowledgement </button> */}
                    </div>
                    {/* <div className="col-1">
                        <button className="btn2 btn-sms1 float-right rounded-pill" onClick={() => this.handleRevise()} > Revise </button>
                    </div> */}
                    <div className="col-1">
                        <CSVLink className="btn2 btn-sms1 float-right rounded-pill" data={this.state.csvData}>export</CSVLink>
                    </div>
                    <div className="col-1">
                        <button className="btn2 btn-sms1 float-right rounded-pill" onClick={() => this.UploadDocumentmodal()}> Import </button>
                    </div>
                    <div className="col-3">
                        <div className="from-group " >
                            <SearchBar placeholder="Search" label="Search" btnName="" />
                        </div>
                    </div>
                </div>


                <div className="col-12 pr-4 pb-2">
                    <div className="p-2 border-radius-modal">

                        <div className="form-group row mb-0" >
                            <div className="col-md-2">
                                <label for="input" className=" form-label"><b>Total Approved Amount:</b></label>
                            </div>
                            <div className="col-md-6">
                                <label for="input" className=" form-label">
                                    {(this.props.invoices.loading == false) ?
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.approvedAmount} readOnly />
                                        </div>
                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>
                                    }
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-block pr-4 " >
                    <div className="scrolling-bar-table">
                        <table border="1" className="table1" >
                            <tr className="headerbar-treasury ">
                                <th> <input type="checkbox" onClick={this.handleChange} checked={this.state.select} /></th>
                                <th >Plant Code</th>
                                <th style={{ whitespace: "break-spaces" }}>Invoice No</th>
                                <th style={{ whitespace: "break-spaces" }}>Payment Counter</th>
                                <th style={{ whitespace: "break-spaces", minWidth: "99px" }}>Invoice Date</th>
                                {/* Editable Due Date */}
                                <th style={{ minWidth: "99px" }}>Due Date</th>
                                <th style={{ whitespace: "break-spaces", minWidth: "255px" }}>Vendor Name</th>
                                <th style={{ whitespace: "break-spaces", minWidth: "209px" }}>Invoice Type</th>
                                <th>Vendor Type</th>
                                <th>PO No</th>
                                <th>Project code</th>
                                <th>currency</th>
                                <th style={{ minWidth: "99px" }}>Invoice Amount</th>
                                <th>Invoice Amount in (INR)</th>
                                <th>Advance Deduction</th>
                                <th>Retention Deduction</th>
                                <th>LD Deduction</th>
                                <th>TDS Deduction</th>
                                <th>Others Deduction</th>
                                {/* Text Field */}
                                <th>Reason For Others</th>
                                {/* Text Field */}
                                <th>SAP Doc. Number</th>
                                {/* Date Field */}
                                <th style={{ minWidth: "99px" }}>SAP Doc. Date</th>
                                <th>Net Payable Amount</th>
                                <th>Approved Amount</th>
                                <th>Payment Method</th>
                                <th style={{ minWidth: "180px" }}>Status</th>
                                <th style={{ minWidth: "73px" }}>Action</th>
                            </tr>
                            {/* {this.props.invoices.allInvoicesSpl.recordset.map((item) => ( */}
                            {/* {this.props.invoices.allInvoices && this.props.invoices.allInvoices.recordset && this.props.invoices.allInvoices.recordset.length>0 && this.props.invoices.allInvoices.recordset.map((item,Index)=> */}
                            {(this.props.invoices.loading == false) ?
                                this.props.invoices.allInvoicesSpl && this.props.invoices.allInvoicesSpl.recordset && this.props.invoices.allInvoicesSpl.recordset.length > 0 && this.state.invoicetabledata.map((item, Index) =>
                                    <tr className="rows headeralign">
                                        <td> <input type="checkbox" checked={this.state.selected && this.state.selected.length > 0 && this.state.selected[item.InvoiceId] && this.state.selected[item.InvoiceId] == true ? true : false} onChange={(event) => this.handleSingleCheckboxChange(item.InvoiceId, item.InvoiceAmountinINR, item.TotalPaidAmount, item.InvoiceNo)} value="" />  </td>
                                        <td>{item.PlantCode}</td>
                                        <td>{item.InvoiceNo}</td>
                                        <td>{item.Counter !== null ? `Part-${item.Counter}` : ''}</td>
                                        <td>{dateFormater(this.formatDate(item.InvoiceDate))}</td>
                                        <td>{dateFormater(this.formatDate(item.DueDate))}</td>
                                        <td>{item.VendorName + " - " + item.VendorSapId}</td>
                                        <td>{item.PaymentTypeName + " Against " + item.TypeFor}</td>
                                        <td>{item.SSIType == "" ? "NON MSME" : "MSME"}</td>
                                        <td>{item.POSAPId}</td>
                                        <td>
                                            {item.WBSNo ?
                                                item.WBSNo.substring(0, 2) == 'ET' ? (item.WBSNo).slice(0, 11) : (item.WBSNo).slice(0, 6)
                                                : 'Others'}
                                        </td>
                                        <td>{item.CurrencyType}</td>
                                        <td className="align-middle amount-text">{item.InvoiceAmount ? numberWithCommas(item.InvoiceAmount) : 0} </td>
                                        <td className="align-middle amount-text">{item.InvoiceAmountinINR ? numberWithCommas(item.InvoiceAmountinINR) : 0}</td>
                                        <td className="align-middle amount-text">{item.AdvanceDeduction ? numberWithCommas(item.AdvanceDeduction) : 0}</td>
                                        <td className="align-middle amount-text">{item.RetentionDeduction ? numberWithCommas(item.RetentionDeduction) : 0}</td>
                                        <td className="align-middle amount-text">{item.LDDeduction ? numberWithCommas(item.LDDeduction) : 0}</td>
                                        <td className="align-middle amount-text">{item.TDSDeduction ? numberWithCommas(item.TDSDeduction) : 0}</td>
                                        <td className="align-middle amount-text">{item.OthersDeduction ? numberWithCommas(item.OthersDeduction) : 0}</td>
                                        <td>{item.ReasonForOthersDeduction}</td>
                                        <td>{item.SAPDocNo}</td>
                                        <td>{item.SAPDocDate ? dateFormater(item.SAPDocDate) : ""}</td>
                                        <td className="align-middle amount-text">{numberWithCommas(item.NetPayableAmount)}</td>
                                        <td className="align-middle amount-text">{numberWithCommas(item.PayableAmount)}</td>
                                        <td>{item.PaymentMediumName}</td>
                                        <td>{item.InvoiceStatusName}</td>
                                        <td>
                                            <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: item.PurchaseOrderId, poSAPId: item.POSAPId, InvoiceId: item.InvoiceId, InvoiceStatusId: item.InvoiceStatusId } }}>
                                                <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                                            </Link>
                                            <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(item.InvoiceId)} />
                                        </td>
                                    </tr>
                                )
                                : null}
                        </table>
                    </div>
                </div>
                <br />
                <br />
                <br />

            </div>
        )
    }
}

const mapStateToProps = (state) => ({ invoices: state.invoice, masterReducerData: state.masterReducer })
export default connect(mapStateToProps, {
    getAllInvoicesForSpecialCase, getDueAmounts, getallMasterData, updateStatusForFinance, getBudgetAmount, postMapPaymentAcknowledgementDocumentIDsToInvoice
})(ReqPayment)
